import { CompleteAccountModalContext, ModalContext, openRegisterForAuctionModal } from '@/redux/modules/modal';
import { EventContext } from '@/redux/modules/analytics';
import { getCatalogIsInstantAutopay } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';

type Props = {
    catalogId: number;
    itemId: number;
};

export const useRegisterForAuction = ({ catalogId, itemId }: Props) => {
    const dispatch = useAppDispatch();
    const isInstantAutopay = useAppSelector((state) => getCatalogIsInstantAutopay(state, catalogId));

    return useCallback(() => {
        const modalContext: ModalContext = {
            catalogId,
            eventContext: EventContext.registerForAuction,
            id: catalogId,
            type: CompleteAccountModalContext.RegisterForAuction,
        };

        dispatch(
            openRegisterForAuctionModal({
                catalogId,
                fromBiddingConsole: false,
                isInstantAutopay,
                itemId,
                modalContext,
            })
        );
    }, [catalogId, dispatch, isInstantAutopay, itemId]);
};
